export default {"src":"/_next/static/media/first_nav_icon06.e286831a.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};